import BackspaceIcon from '@mui/icons-material/Backspace';
import SearchIcon from '@mui/icons-material/Search';
import {
  Box,
  FormControl,
  FormControlLabel,
  IconButton,
  InputLabel,
  MenuItem,
  Radio,
  RadioGroup,
  Select,
} from '@mui/material';
import Grid from '@mui/material/Unstable_Grid2';
import { DatePicker } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { useContext, useState } from 'react';
import { OrgSettingsContext } from '../../../contexts/org-settings-context';
import {
  DoubleDate,
  DoubleDateMode,
  DoubleDateWithMode,
} from '../double-date-picker/double-date-picker.interfaces';

interface DoubleDateFilterWithModesProps {
  dateFilterAction: (d: DoubleDateWithMode) => void;
  headless?: boolean;
  modes?: DoubleDateMode[];
}

function DoubleDateFilterWithModes({
  dateFilterAction,
  headless,
  modes = [DoubleDateMode.CREATION_DATE, DoubleDateMode.DELIVERY_DATE],
}: DoubleDateFilterWithModesProps) {
  const [dateFilter, setDateFilter] = useState<DoubleDateWithMode>({
    startDate: null,
    endDate: null,
    mode: modes[0],
  });

  const { color } = useContext(OrgSettingsContext);

  return (
    <Box component="fieldset" border={'none'} p={0}>
      {!headless && (
        <legend>
          <b>Date Controls</b>
        </legend>
      )}

      <form>
        <RadioGroup
          aria-labelledby="demo-radio-buttons-group-label"
          row
          name="radio-buttons-group"
          onChange={(e) =>
            setDateFilter({
              ...dateFilter,
              mode: e.target.value as DoubleDateMode,
            })
          }
        >
          {modes.map((mode) => (
            <FormControlLabel
              key={mode}
              checked={dateFilter.mode === mode}
              value={mode}
              control={<Radio />}
              label={mode}
            />
          ))}
        </RadioGroup>
        <Grid container spacing={1} width={'100%'}>
          <Grid xs={12} md={4}>
            <FormControl fullWidth>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  label="From"
                  value={dateFilter.startDate}
                  onChange={(newValue) =>
                    setDateFilter({
                      ...dateFilter,
                      startDate: newValue,
                    })
                  }
                />
              </LocalizationProvider>
            </FormControl>
          </Grid>

          <Grid xs={12} md={4}>
            <FormControl fullWidth>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  label="To"
                  value={dateFilter.endDate}
                  onChange={(newValue) =>
                    setDateFilter({
                      ...dateFilter,
                      endDate: newValue,
                    })
                  }
                />
              </LocalizationProvider>
            </FormControl>
          </Grid>

          <Grid xs={12} md={4}>
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                height: '100%',
              }}
            >
              <IconButton
                type="submit"
                aria-label="search"
                onClick={(e) => {
                  e.preventDefault();
                  dateFilterAction(dateFilter);
                }}
              >
                <SearchIcon style={{ fill: `${color}` }} />
              </IconButton>

              <IconButton
                type="submit"
                aria-label="search"
                onClick={(e) => {
                  e.preventDefault();
                  setDateFilter({
                    mode: dateFilter.mode,
                    startDate: null,
                    endDate: null,
                  });
                  dateFilterAction({
                    mode: dateFilter.mode,
                    startDate: null,
                    endDate: null,
                  });
                }}
              >
                <BackspaceIcon style={{ fill: `${color}` }} />
              </IconButton>
            </div>
          </Grid>
        </Grid>
      </form>
    </Box>
  );
}

export default DoubleDateFilterWithModes;
